module.exports = __webpack_public_path__ + "img/logo4.d0f15455.png";